import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import InspectionTypeContracts from './InspectionType'
import FormContracts from './FormSelection'
import StatusContracts from './Status'
import DurationContracts from './Duration'
import { ClipboardList } from 'lucide-react'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'
import Location from './Location'
import FacilitiesContracts from './Facilities'
import ContractEquip from './ContractEquip'

function ContractsSettings() {
    return(
        <>
        
             <HeadingWithIcon icon={ClipboardList} title="Contracts" />

        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
       
         {/* <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <FormContracts/>
         </div> */}
          <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Location/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <InspectionTypeContracts/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusContracts/>
         </div>

{/* <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <ContractEquip/>
         </div> */}

          <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <FacilitiesContracts/>
         </div>
        
       
         </div>
         </>
    )
}

export default ContractsSettings
